import {Injectable} from '@angular/core';
import {ResponseData} from '../../ResponseData.interface';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {v4 as uuid} from 'uuid';
import {environment} from '../../../../environments/environment.prod';

const COLLECTION_URL = environment.API_URL + 'collection';

@Injectable()
export class CollectionService {
  id: string;

  constructor(private http: HttpClient) {
  }

  getCollections(page_size?: number, page_no?: number) {
    const request: any = {page_size, page_no};
    return this.http.get<ResponseData>(COLLECTION_URL, {params: request});
  }

  
  getSearchedCollection(parameters): Observable<ResponseData> {
    return this.http.get<ResponseData>(COLLECTION_URL + '/search-side-bar', {params: parameters});
  }

  getSearchResults(parameters): Observable<ResponseData> {
    return this.http.get<ResponseData>(COLLECTION_URL + '/search', {params: parameters});
  }

}
